export default __webpack_public_path__ + "img/create-link.1c0ef238.svg";